import request from '../index'

/**
 * 获取短信验证码
 * @param {*} data
 * @returns
 */
export function getSmsCode(data) {
    return request({
        url: '/user/smsloginSendcode',
        method: 'post',
        data
    })
}

/**
 * 用户登录
 * @param {*} data
 * @returns
 */
export function smslogin(data) {
    return request({
        url: '/user/smslogin',
        method: 'post',
        data
    })
}

/**
 * 注销账号发送验证码
 */
export function offAccountSendCode(data) {
    return request({
        url: '/user/smsoffSendcode',
        method: 'post',
        data
    })
}

/**
 * 注销账号
 */
export function offAccount(data) {
    return request({
        url: '/user/off',
        method: 'post',
        data
    })
}

/**
 * 绑定手机号发送验证码
 */
export function bindMobileSendCode(data) {
    return request({
        url: '/user/bindMobile/sendCode',
        method: 'post',
        data
    })
}

/**
 * 绑定手机号
 */
export function userBindMobile(data) {
    return request({
        url: '/user/bindMobile/checkCode',
        method: 'post',
        data
    })
}

/**
 * 更新信息
 */
export function updateInfo(data) {
    return request({
        url: '/user/updateUserInfo',
        method: 'post',
        data
    })
}

/**
 * 获取用户基本信息
 * @param {*} query
 * @returns
 */
export function getUserBasicInfo() {
    return request({
        url: '/user/info',
        method: 'get'
    })
}

/**
 * 获取用户VIP信息
 * @param {*} query
 * @returns
 */
export function getUserVipInfo() {
    return request({
        url: '/box/user/info',
        method: 'get'
    })
}

/**
 * 获取用户实名信息
 * @param {*} query
 * @returns
 */
export function getUserAuthInfo() {
    return request({
        url: '/user/realuser/get',
        method: 'get'
    })
}

/**
 * 用户实名认证
 * @param {*} data
 * @returns
 */
export function setUserAuth(data) {
    return request({
        url: '/user/realuser/set',
        method: 'post',
        data
    })
}

/**
 * 获取微信登录ticket
 * @returns
 */
export function getWxTicket(params) {
    return request({
        url: '/user/wx/ticket',
        method: 'get',
        params
    })
}

/**
 * 查询微信登录的token
 * @param {*} params
 * @returns
 */
export function getWxLoginToken(params) {
    return request({
        url: '/user/getTokenForTicket',
        method: 'get',
        params,
        'axios-retry': {
            retries: 0
        }
    })
}

/**
 * 获取微信登录ticket
 * @returns
 */
export function getWxTicketByCode(params) {
    return request({
        url: '/user/getTokenForCode',
        method: 'get',
        params
    })
}

/**
 * 获取限免游戏时长
 * @returns
 */
export function getLimitFree(params) {
    return request({
        url: '/box/user/getFamilyFreeGame',
        method: 'get',
        params
    })
}

/**
 * 获取限免到期时间
 * @returns
 */
export function getLimitFreeTime(params) {
    return request({
        url: '/box/user/FamilyFreeGameTime',
        method: 'get',
        params
    })
}

/**
 * 同意协议
 * @returns
 */
export function agreeUserAgreement(data) {
    return request({
        url: '/user/agreement/confirm',
        method: 'post',
        data
    })
}
